
//eslint-disable-next-line

const iconSize = {
  xxs: 12,
  sm: 16,
  md: 18,
  mbl: 20,
  mldsk: 22,
  dsk: 24,
  lg: 30,
  xlg: 32,
};

export { iconSize };
